/**
 * oidc-client-ts throws `ErrorResponse` only when the token endpoint answers
 * with an OAuth error payload; network failures, timeouts and 5xx surface as a
 * plain `Error`. So only `invalid_grant` proves the refresh token is dead —
 * anything else leaves the session usable and must not sign the user out.
 *
 * Note this only works against a UserManager method. react-oidc-context's
 * `useAuth().signinSilent` swallows the error and resolves with `null`, which
 * is why renewal goes through the manager from `@/lib/auth/auth-manager`.
 */
export function isDeadSessionError(error: unknown): boolean {
  return (
    error instanceof Error &&
    error.name === 'ErrorResponse' &&
    (error as { error?: string | null }).error === 'invalid_grant'
  )
}
